// extracted by mini-css-extract-plugin
export var form = "_bo-0";